// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/DotGothic16-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/PressStart2P-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/PixelifySans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/GohuFont14NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/BigBlueTerm437NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/HeavyDataNerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DotGothic16";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"); }

@font-face {
  font-family: "Press Start 2P";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Pixelify Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Gohu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Big Blue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Heavy Data";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

:root {
  --main-font: "Pixelify Sans", sans-serif;
  --clock-font: "DotGothic16", sans-serif;
  --log-in-font: "Press Start 2P", sans-serif;
  --Gohu-test: "Gohu", sans-serif;
  --Big-Blue-test: "Big Blue", sans-serif;
  --Heavy-Data-test: "Heavy Data", sans-serif; }

.topBar {
  background-color: #cccccc;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0px;
  border-top: 1px white solid;
  border-bottom: 1px black solid;
  border-right: 1px black solid;
  border-left: 1px white solid; }

.cycle-btn {
  background-color: #cccccc;
  margin-left: 5px;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid;
  font-family: var(--main-font); }
  .cycle-btn:hover {
    cursor: pointer; }
  .cycle-btn:active {
    background-color: #969696;
    border-top: 1px black solid;
    border-right: 1px white solid;
    border-bottom: 1px white solid;
    border-left: 1px black solid; }

.clock {
  margin-right: 5px;
  padding: 2px 5px;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid;
  font-family: var(--clock-font);
  font-size: medium; }
  .clock :hover {
    cursor: default; }

.clear-btn {
  margin-right: 5px;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid;
  background-color: #CCCCCC; }
  .clear-btn:active {
    border-top: 1px black solid;
    border-right: 1px white solid;
    border-bottom: 1px white solid;
    border-left: 1px black solid; }
  @media (max-width: 430px) {
    .clear-btn {
      display: none; } }

.splash-div {
  background-color: #0b17b4;
  color: white;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: 50% 50%;
  background-size: 100% 100%; }
  @media screen and (max-width: 430px) {
    .splash-div {
      align-items: flex-start;
      background-size: 200% 100%; } }

.disclaimer {
  position: absolute;
  bottom: 0;
  left: 0;
  font-family: var(--main-font); }
  .disclaimer:hover {
    cursor: default; }

@media screen and (max-width: 430px) {
  .name-img {
    margin-top: 60px;
    width: 80%; } }
`, "",{"version":3,"sources":["webpack://./src/components/style_imports/_fonts.scss","webpack://./src/components/SplashStyle.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,+DAAkE,EAAA;;AAGtE;EACI,6BAA6B;EAC7B,4CAAgD,EAAA;;AAGpD;EACI,4BAA4B;EAC5B,4CAAgD,EAAA;;AAGpD;EACI,mBAAmB;EACnB,4CAAsD,EAAA;;AAG1D;EACI,uBAAuB;EACvB,4CAA0D,EAAA;;AAG9D;EACI,yBAAyB;EACzB,4CAAqD,EAAA;;AAGzD;EACI,wCAAY;EACZ,uCAAa;EACb,2CAAc;EACd,+BAAY;EACZ,uCAAgB;EAChB,2CAAkB,EAAA;;AClCtB;EACI,yBAAoC;EACpC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B,EAAA;;AAGhC;EACI,yBAAoC;EACpC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAE5B,6BAA6B,EAAA;EARjC;IAWQ,eAAe,EAAA;EAXvB;IAeQ,yBAAoC;IACpC,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B,EAAA;;AAIpC;EACI,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB,EAAA;EARrB;IAWQ,eAAe,EAAA;;AAIvB;EACI,iBAAiB;EAEjB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAE5B,yBAAyB,EAAA;EAR7B;IAWQ,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B,EAAA;EAGhC;IAjBJ;MAkBQ,aAAa,EAAA,EAEpB;;AAED;EACI,yBAAkC;EAClC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EAEnB,4BAA4B;EAC5B,0BAA0B,EAAA;EAE1B;IAZJ;MAaQ,uBAAuB;MACvB,0BAA0B,EAAA,EAEjC;;AAED;EACI,kBAAkB;EAClB,SAAS;EACT,OAAO;EAEP,6BAA6B,EAAA;EALjC;IAQQ,eAAe,EAAA;;AAKnB;EADJ;IAEQ,gBAAgB;IAChB,UAAU,EAAA,EAEjB","sourcesContent":["@font-face {\n    font-family: \"DotGothic16\";\n    src: url(\"../../fonts/DotGothic16-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"Press Start 2P\";\n    src: url(\"../../fonts/PressStart2P-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Pixelify Sans\";\n    src: url(\"../../fonts/PixelifySans-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Gohu\";\n    src: url(\"../../fonts/GohuFont14NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Big Blue\";\n    src: url(\"../../fonts/BigBlueTerm437NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Heavy Data\";\n    src: url(\"../../fonts/HeavyDataNerdFont-Regular.ttf\");\n}\n\n:root {\n    --main-font: \"Pixelify Sans\", sans-serif;\n    --clock-font: \"DotGothic16\", sans-serif;\n    --log-in-font: \"Press Start 2P\", sans-serif;\n    --Gohu-test: \"Gohu\", sans-serif;\n    --Big-Blue-test: \"Big Blue\", sans-serif;\n    --Heavy-Data-test: \"Heavy Data\", sans-serif;\n}","@import './style_imports/fonts';\n\n.topBar {\n    background-color: rgb(204, 204, 204);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 30px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 3px 0px;\n    border-top: 1px white solid;\n    border-bottom: 1px black solid;\n    border-right: 1px black solid;\n    border-left: 1px white solid;\n}\n\n.cycle-btn {\n    background-color: rgb(204, 204, 204);\n    margin-left: 5px;\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n\n    font-family: var(--main-font);\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    &:active {\n        background-color: rgb(150, 150, 150);\n        border-top: 1px black solid;\n        border-right: 1px white solid;\n        border-bottom: 1px white solid;\n        border-left: 1px black solid;\n    }\n}\n\n.clock {\n    margin-right: 5px;\n    padding: 2px 5px;\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n    font-family: var(--clock-font);\n    font-size: medium;\n\n    & :hover {\n        cursor: default;\n    }\n}\n\n.clear-btn {\n    margin-right: 5px;\n\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n\n    background-color: #CCCCCC;\n\n    &:active {\n        border-top: 1px black solid;\n        border-right: 1px white solid;\n        border-bottom: 1px white solid;\n        border-left: 1px black solid;\n    }\n\n    @media (max-width: 430px) {\n        display: none;\n    }\n}\n\n.splash-div {\n    background-color: rgb(11, 23, 180);\n    color: white;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background-position: 50% 50%;\n    background-size: 100% 100%;\n\n    @media screen and (max-width: 430px) {\n        align-items: flex-start;\n        background-size: 200% 100%;\n    }\n}\n\n.disclaimer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n\n    font-family: var(--main-font);\n\n    &:hover {\n        cursor: default;\n    }\n}\n\n.name-img {\n    @media screen and (max-width: 430px) {\n        margin-top: 60px;\n        width: 80%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
